import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { purpurColorGray50, purpurColorGreen600, purpurColorOrange600, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import DeviceStatus from 'constants/deviceStatus';
import styled from 'styled-components';
const TableWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const RowStyled = styled.div `
  display: flex;
  flex-direction: row;
  padding: 6px 10px;

  &:nth-of-type(even) {
    background-color: ${purpurColorGray50};
  }
`;
const Cell = styled.div `
  display: flex;
  flex: 1 1 0;
  justify-content: center;
  text-align: center;
  word-break: break-word;
`;
const HeaderCell = styled(Cell) `
  font-weight: 600;
  font-size: 18px;
`;
const ValueText = styled.span `
  color: ${({ status }) => {
    switch (status) {
        case DeviceStatus.OK:
            return purpurColorGreen600;
        case DeviceStatus.WARN:
            return purpurColorOrange600;
        case DeviceStatus.ERROR:
            return purpurColorRed600;
        default:
            return 'inherit';
    }
}};
`;
export const Table = ({ columns, rows, columnValueTypes }) => {
    const columnNames = columns.filter(column => column !== '');
    return (_jsxs(TableWrapper, { children: [_jsx(RowStyled, { children: columnNames.map(column => (_jsx(HeaderCell, { children: column }, column))) }), rows.map(row => (_jsxs(RowStyled, { children: [_jsx(Cell, { children: row.name }), columnValueTypes.map(type => {
                        const propertyValue = row.propertyValues.find(value => value.type === type);
                        if (!propertyValue) {
                            return _jsx(Cell, {}, type);
                        }
                        const { first, second } = propertyValue.value;
                        return (_jsx(Cell, { children: _jsxs("div", { children: [_jsx(ValueText, { status: first === null || first === void 0 ? void 0 : first.valueStatus, children: first === null || first === void 0 ? void 0 : first.value }), (second === null || second === void 0 ? void 0 : second.value) && (_jsxs(_Fragment, { children: [_jsx("span", { children: " / " }), _jsx(ValueText, { status: second.valueStatus, children: second.value })] }))] }) }, type));
                    })] }, row.name)))] }));
};
